import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#4da6ff', '#6efb6e', '#c084fc', '#fb923c', '#f43f5e', '#facc15', '#22d3ee'];

const LABELS = {
  STOCKS: 'Indian Stocks', STOCKS_MF: 'Stocks/MF', MF: 'Mutual Funds',
  US_STOCKS: 'US Stocks', DSOP: 'DSOP', BANK: 'Bank', NPS: 'NPS',
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div style={{ background: '#1a1a2e', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '8px 12px' }}>
      <p style={{ color: 'var(--text)', fontSize: '12px', fontWeight: 600 }}>{LABELS[d.name] || d.name}</p>
      <p style={{ color: payload[0].fill, fontSize: '12px' }}>{d.pct?.toFixed(1)}%</p>
    </div>
  );
};

export default function AllocationPie({ data = {} }) {
  const chartData = Object.entries(data)
    .map(([name, v]) => ({ name, value: v.value, pct: v.pct }))
    .sort((a, b) => b.value - a.value);

  return (
    <div className="dash-card relative rounded-2xl p-5 h-full overflow-hidden flex flex-col" style={{
      background: 'var(--card-grad)',
      border: '1px solid rgba(255,255,255,0.09)',
      boxShadow: '0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)',
      backdropFilter: 'blur(14px)',
      '--card-accent': '#60a5fa', '--card-accent-glow': 'rgba(96,165,250,0.22)',
    }}>
      <div className="card-glow" style={{ position: 'absolute', top: '-50px', left: '-30px', width: '180px', height: '180px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(96,165,250,0.16) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <p className="relative font-semibold mb-2 flex-none" style={{ color: 'var(--text-dim)', fontSize: '16px' }}>Allocation</p>
      <div className="flex-1 min-h-0" style={{ minHeight: '128px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius="58%"
            outerRadius="88%"
            paddingAngle={2}
            dataKey="value"
            isAnimationActive={false}
          >
            {chartData.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} strokeWidth={0} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      </div>
      {/* Legend */}
      <div className="grid grid-cols-2 gap-x-5 gap-y-1.5 mt-3 flex-none">
        {chartData.map((d, i) => {
          const fmtV = v => v >= 1e7 ? `₹${(v/1e7).toFixed(1)}Cr` : v >= 1e5 ? `₹${(v/1e5).toFixed(1)}L` : `₹${Math.round(v).toLocaleString('en-IN')}`;
          return (
            <div key={d.name} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: COLORS[i % COLORS.length] }} />
                <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>{LABELS[d.name] || d.name}</span>
              </div>
              <div className="flex items-center gap-3">
                <span style={{ color: 'var(--text-dim)', fontSize: '12px', fontFamily: 'monospace' }}>{fmtV(d.value)}</span>
                <span style={{ color: 'var(--text)', fontSize: '13px', fontWeight: 600, minWidth: '34px', textAlign: 'right' }}>{d.pct.toFixed(0)}%</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
